import executeRequest, { RequestOutput } from 'app/api'

enum APIEndpoint {
  GetAllRiskNoticeStatuses = 'api/riskNoticeStatuses',
}



export type GetAllRiskNoticeStatusesResponse = {
  riskNoticeStatuses: {
    id: number,
    name: string
    keyword: string
  }[]
}

enum GetAllRiskNoticeStatusesResponseError {
}

export async function getAllRiskNoticeStatuses(output?: RequestOutput<GetAllRiskNoticeStatusesResponse, GetAllRiskNoticeStatusesResponseError>) {
  executeRequest({
    endpoint: APIEndpoint.GetAllRiskNoticeStatuses,
    output: output,
  })
}
